module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/murin1-9d2e9291dff3b792f00c04baa49057d7.jpg";